  <template>
  <div>
    <v-dialog v-model="dialog" max-width="500px" :retain-focus="false">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-bind:valid="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" v-if="!editedItem.id">
                  <v-select
                    v-model="editedItem.incidentType.id"
                    :label="$t('_incident.incidentType')"
                    :items="incidentTypes"
                    item-text="name"
                    item-value="id"
                    :rules="incidentRules"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-textarea
                    v-model="editedItem.description"
                    :label="$t('_incident.description')"
                    rows="2"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" v-if="!editedItem.id">
                  <v-select
                    v-model="editedItem.countyCode"
                    :label="$t('_place.county')"
                    :items="counties"
                    item-text="name"
                    item-value="code"
                    :rules="countyRules"
                    @change="changeNeigh(editedItem.countyCode)"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" v-if="!editedItem.id">
                  <v-select
                    v-model="editedItem.neighborhoodCode"
                    :label="$t('_place.neighborhood')"
                    :items="
                      neighborhoods.filter(
                        (n) => n.countyCode === this.editedItem.countyCode
                      )
                    "
                    item-text="name"
                    item-value="code"
                    :disabled="this.editedItem.countyCode === null"
                    required
                    :rules="neighborhoodRules"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="editedItem.lat"
                    :label="$t('_place.lat')"
                    :rules="latRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="editedItem.lon"
                    :label="$t('_place.lon')"
                    :rules="lonRules"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex flex-column" cols="12" sm="4">
                  <v-btn
                    style="margin-top: 15px"
                    color="blue darken-1"
                    text
                    @click="mapDialog = true"
                  >
                    {{ $t("_map._select").toLocaleUpperCase(lang) }}
                  </v-btn>
                  <v-map-location-select
                    type="incident"
                    :mapDialog.sync="mapDialog"
                    :cId="categoryId"
                    :routeName="routeName"
                    :points="editedItem"
                    @confirmedLoc="onConfirmedLoc"
                    @cancelledLoc="onCancelledLoc"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editedItem.startDate"
                        :label="$t('_date.startDate')"
                        prepend-icon="mdi-calendar"
                        readonly
                        :rules="[rules.startDateRules]"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editedItem.startDate"
                      :locale="lang"
                      :max="editedItem.endDate"
                      @input="menu1 = false"
                      @change="changeDate()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editedItem.endDate"
                        :label="$t('_date.endDate')"
                        prepend-icon="mdi-calendar"
                        readonly
                        :rules="[rules.endDateRules]"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editedItem.endDate"
                      :locale="lang"
                      :min="editedItem.startDate"
                      @input="menu2 = false"
                      @change="changeDate()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-menu
                    ref="timeStartMenu"
                    v-model="timeMenu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="editedItem.startTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editedItem.startTime"
                        :label="$t('_date.startTime')"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        :rules="[rules.startTimeRules]"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="timeMenu1"
                      v-model="editedItem.startTime"
                      full-width
                      scrollable
                      format="24hr"
                      @click:minute="
                        $refs.timeStartMenu.save(editedItem.startTime)
                      "
                    ></v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                    ref="timeEndMenu"
                    v-model="timeMenu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="editedItem.endTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editedItem.endTime"
                        :disabled="editedItem.startTime === null"
                        :label="$t('_date.endTime')"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        :rules="[rules.endTimeRules]"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      ref="endTimePicker"
                      v-if="timeMenu2"
                      v-model="editedItem.endTime"
                      format="24hr"
                      scrollable
                      :allowed-minutes="allowedMinutes"
                      :allowed-hours="allowedHours"
                      full-width
                      @click:minute="$refs.timeEndMenu.save(editedItem.endTime)"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <p v-if="hasError == true" class="red--text">{{ errorMessage }}</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="save" v-bind:valid="valid">
            {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="closeSnack()">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import VMap from "@/components/ui/VMap.vue";
import VMapLocationSelect from "@/components/ui/VMapLocationSelect.vue";
import { mapGetters } from "vuex";

export default {
  components: { VMap, VMapLocationSelect },
  props: {
    dialog: Boolean,
    editedItem: Object,
    editedIndex: Number,
    counties: Array,
    neighborhoods: Array,
    incidentTypes: Array,
    routeName: String,
    categoryId: String,
  },
  data() {
    return {
      rules: {
        startDateRules: (v) => !!v || "Başlangıç Tarihi Girilmelidir",
        endDateRules: (v) => !!v || "Bitiş Tarihi Girilmelidir",

        startTimeRules: (v) => !!v || "Başlangıç Zamanı Girilmelidir",
        endTimeRules: (v) => !!v || "Bitiş Zamanı Girilmelidir",

        startEndTimeRules: (v) =>
          (this.editedItem.startDate != this.editedItem.endDate &&
            v < this.editedItem.endTime) ||
          "Bitiş Zamanı, Başlangıç Zamanından Önce Olmamalıdır!",
      },
      mapDialog: false,
      locSelected: [{ lat: null, lon: null }],
      valid: false,
      disabled: false,
      dialog: false,
      dialogDelete: false,
      defaultItem: {
        name: "",
        address: "",
        phone: "",
      },
      snackbar: false,
      snackColor: "",
      snackText: "",
      x: "",
      y: "",
      mode: "",
      timeout: 3000,
      nameRules: [(v) => !!v || "Ad Girilmelidir"],
      incidentRules: [(v) => !!v || "Olay Tipi Seçilmelidir"],
      countyRules: [(v) => !!v || "İlçe Seçilmelidir"],
      neighborhoodRules: [(v) => !!v || "Mahalle Seçilmelidir"],

      latRules: [
        (v) => !!v || "Enlem Girilmelidir",
        (v) =>
          // /^(\+|-)?((\d((\.)|\.\d{1,6})?)|(0*?[0-8]\d((\.)|\.\d{1,6})?)|(0*?90((\.)|\.0{1,6})?))$/.test(v) ||
          // /^[+-]?\d*\.\d+$|^[+-]?\d+(\.\d*)?$/.test(v) ||
          // /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/.test(v) ||
          /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[3][6-9]|[4][0-2])(?:(?:\.[0-9]{1,6})?))$/.test(
            v
          ) ||
          "Türkiye sınırları içerisinde geçerli bir enlem girilmelidir! (36.xx - 42.xx)",
      ],
      lonRules: [
        (v) => !!v || "Boylam Girilmelidir",
        (v) =>
          // ^[+-]?\d*\.\d+$|^[+-]?\d+(\.\d*)?$
          /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[2][6-9]|[3][0-9]|[4][0-5])(?:(?:\.[0-9]{1,6})?))$/.test(
            v
          ) ||
          "Türkiye sınırları içerisinde geçerli bir boylam girilmelidir! (26.xx - 45.xx)",
      ],
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu1: false,
      menu2: false,
      startTime: null,
      timeMenu1: false,
      endTime: null,
      timeMenu2: false,
      start: null,
      end: null,
      hasError: false,
      errorMessage: "Zorunlu alanlar doldurulmalıdır!",
    };
  },

  computed: {
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("common.new") + " " + this.$t("_incident.incident")
        : this.$t("common.edit");
    },
  },
  watch: {
    language: function () {
      console.log("lang changed");
    },
    dialog(val) {
      this.hasError = false;
      this.$refs.form.resetValidation();
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    async closeSnack() {
      this.snackbar = false;
    },
    allowedHours(v) {
      let startHour = this.editedItem.startTime.split(":")[0];
      if (this.editedItem.startDate == this.editedItem.endDate) {
        return v >= startHour;
      } else {
        return (v) => v;
      }
    },
    allowedMinutes(v) {
      let hour = this.editedItem.startTime.split(":")[0];
      if (
        this.editedItem.startDate == this.editedItem.endDate &&
        this.$refs.endTimePicker.inputHour == hour
      ) {
        return v > this.editedItem.startTime.split(":")[1];
      } else {
        return (v) => v;
      }
    },
    changeNeigh(county) {},
    changeDate() {
      if (this.editedItem.startDate == this.editedItem.endDate) {
        this.editedItem.endTime = null;
      }
    },
    close() {
      this.dialog = false;
      this.$emit("cancelled");

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      var startTimeAndDate =
        this.editedItem.startDate + " " + this.editedItem.startTime;
      var endTimeAndDate =
        this.editedItem.endDate + " " + this.editedItem.endTime;

      if (this.$refs.form.validate()) {
        this.hasError = false;

        this.valid = true;
        if (this.editedIndex > -1) {
          //Object.assign(this.counties[this.editedIndex], this.editedItem);
          try {
            await this.$store.dispatch("incidents/update", {
              incidentId: this.editedItem.id,
              description: this.editedItem.description,
              lat: this.editedItem.lat,
              lon: this.editedItem.lon,
              startDate: startTimeAndDate,
              endDate: endTimeAndDate,
            });
            // this.editedItem.incidentType.id = "";
            this.editedItem.countyCode = "";
            this.editedItem.neighborhoodCode = "";
            this.editedItem.address = "";
            this.editedItem.phone = "";
            this.editedItem.lat = "";
            this.editedItem.lon = "";
            this.editedItem.startDate = "";
            this.editedItem.endDate = "";
            this.editedItem.startTime = "";
            this.editedItem.endTime = "";
            this.snackbar = true;
            this.snackColor = "success";
            this.snackText = "Kayıt güncellendi.";
          } catch (e) {
            this.snackbar = true;
            this.snackColor = "error";
            this.snackText = "Kayıt güncellenemedi";

            console.error(e);
          }
        } else {
          try {
            await this.$store.dispatch("incidents/create", {
              incidentTypeId: this.editedItem.incidentType.id,
              description: this.editedItem.description,
              cityCode: this.editedItem.cityCode,
              countyCode: this.editedItem.countyCode,
              neighborhoodCode: this.editedItem.neighborhoodCode,
              lat: this.editedItem.lat,
              lon: this.editedItem.lon,
              startDate: startTimeAndDate,
              endDate: endTimeAndDate,
            });
            this.editedItem.incidentType.id = "";
            this.editedItem.description = "";
            this.editedItem.countyCode = "";
            this.editedItem.neighborhoodCode = "";
            this.editedItem.address = "";
            this.editedItem.phone = "";
            this.editedItem.lat = "";
            this.editedItem.lon = "";
            this.editedItem.startDate = null;
            this.editedItem.endDate = null;
            this.editedItem.startTime = null;
            this.editedItem.endTime = null;
            this.snackbar = true;
            this.snackColor = "success";
            this.snackText = "Kayıt eklendi";
            this.x = "center";
            this.y = "bottom";
            this.timeout = 3000;
          } catch (e) {
            this.snackbar = true;
            this.snackColor = "error";
            this.snackText = "Kayıt eklenemedi";
            this.x = "center";
            this.y = "bottom";
          }
        }
        this.$emit("confirmed", this.editedItem);
        this.close();
      } else {
        this.hasError = true;
      }
    },
    onConfirmedLoc(coords) {
      // hide a dialog
      this.locSelected.lat = coords[1].toFixed(6);
      this.locSelected.lon = coords[0].toFixed(6);
      this.editedItem.lat = parseFloat(coords[1].toFixed(6));
      this.editedItem.lon = parseFloat(coords[0].toFixed(6));
      this.mapDialog = false;
      // save a user and refresh a table
    },
    onCancelledLoc(coords) {
      // hide a dialog

      coords[0] = this.editedItem.lon;
      coords[1] = this.editedItem.lat;
      this.mapDialog = false;
    },
    phoneTrim(phone_number) {
      console.log(
        "telefoonononoonn",
        phone_number.replace(/[()\s]/g, "").replace(/^\+90/, "")
      );
      return phone_number.replace(/[()\s]/g, "").replace(/^\+90/, "");
    },
  },
};
</script>